import { UserTable, PATIENT_COLUMNS, SearchBar } from "./usersShared";

/* Patients — a range-scoped, server-paginated, server-searchable table. Metric
   columns follow the range pills; identity is lifetime. */
export const PatientsTab = ({ patients, sort, onSort, onPage, onSearch, loading }) => (
  <UserTable
    title="Patients"
    subtitle="signed up in range · metrics from their activity; identity lifetime"
    columns={PATIENT_COLUMNS}
    data={patients}
    sort={sort}
    onSort={onSort}
    onPage={onPage}
    loading={loading}
    action={<SearchBar placeholder="Search patients by name…" onSearch={onSearch} />}
    emptyText="No patients match — try a different name or range."
  />
);
